import {URL_ENDPOINT} from "src/utils/constants/service";
import {getRequest} from "src/services/api/http";

function search(query: any) {
  const url = URL_ENDPOINT.sanctions.search;
  return getRequest(url, query, undefined, {
    'X-API-KEY': 'oc2MRYUgAUxE5V2jMlXevDyXQ9aeVCZMS6Po0nY9ooM',
  }) as Promise<any>;

}

function getDetail(id: string) {
  const url = URL_ENDPOINT.sanctions.getDetail.replace(':id', id);
  return getRequest(url, {}, undefined, {
    'X-API-KEY': 'oc2MRYUgAUxE5V2jMlXevDyXQ9aeVCZMS6Po0nY9ooM',
  }) as Promise<any>;
}

export const SanctionsService = {
  search,
  getDetail
};
